<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
document.title = "北京中科悦信科技有限公司";
</script>
<style>

</style>
